<template>
  <datepicker
    ref="datepicker"
    v-model="selected"
    :name="name"
    :id="id"
    :format="format"
    :disabled="disabled"
    :disabled-dates="disabledDates"
    maximum-view="day"
    :wrapper-class="wrapperClass"
    :input-class="inputClass"
    calendar-class="dp-calendar"
    @selected="onInputChange"
    v-on:click.native="onClick"
    :positioned="positioned"
    :placeholder="placeholder"
    :clear-button="clearButton"
    :calendar-button="showCalendarButton"
    :calendar-button-icon="calendarButtonIcon"
    :typeable="typeable"
    :use-utc="useUtc"
  >
  </datepicker>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
  props: {
    model: {
      type: [String, Number, Array]
    },
    value: {
      type: [String, Date]
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    onChange: {
      type: Function
    },
    format: {
      type: String,
      default: 'dd MMM yyyy'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minimum: {
      type: Date
    },
    maximum: {
      type: Date
    },
    placeholder: {
      type: String,
      default: 'Set date'
    },
    clearButton: {
      type: Boolean,
      default: false
    },
    showCalendarButton: {
      type: Boolean,
      default: false
    },
    calendarButtonIcon: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: 'dp-input'
    },
    wrapperClass: {
      type: String,
      default: 'dp-wrapper'
    },
    typeable: {
      type: Boolean,
      default: false
    },
    useUtc: {
      type: Boolean,
      default: true
    }
  },

  components: {
    Datepicker
  },

  data: function() {
    return {
      positioned: false
    }
  },

  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },

    disabledDates: function() {
      let dates = {
        to: this.minimum || null,
        from: this.maximum || null
      };

      return dates;
    },

    fixedPosition: function() {
      return this.$refs.datepicker.$el.classList.contains('datatable-datepicker--fixed');
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    onInputChange: function(value) {
      if (this.onChange) this.onChange(value);
    },

    setPosition: function() {
      const datepicker = this.$refs.datepicker.$el;

      if (this.fixedPosition === true) {
        const child = this.$refs['datepicker'].$children[1].$el;
        const relative = this.$refs['datepicker'].$el;

        const offset = {
          top: -40,
          left: 10
        }

        const { top, left, right, bottom, width, height } = relative.getBoundingClientRect();
        child.style.top = (top + offset.top) + 'px';
        child.style.left = (left + width + offset.left) + 'px';

        // Check if it is outside the window.
        const childBounds = child.getBoundingClientRect();
        const windowOffset = 10;
        
        if (childBounds.bottom >= (window.innerHeight || document.documentElement.clientHeight) - windowOffset) {
          const diff = childBounds.bottom - (window.innerHeight || document.documentElement.clientHeight);
          child.style.top = (childBounds.top - diff - windowOffset) + 'px';
        }

        if (childBounds.right >= (window.innerWidth || document.documentElement.clientWidth) - windowOffset) {
          child.style.left = (left - childBounds.width - offset.left) + 'px';
        }
      }
    },

    onClick: function() {
      this.setPosition();
    },

    handleScroll: function() {
      if (this.fixedPosition === true) {
        this.$refs['datepicker'].close();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .dp-wrapper {
    // padding: 4px 40px 4px 4px;
    padding: 4px;
    max-width: 100%;

    :deep(.dp-input) {
      border: none;
      padding: 4px;
      border-radius: 4px;
      max-width: 100%;
      font-size: inherit;

      &:focus {
        outline: none;
        // font-size: 11px;
        color: inherit;
      }

      &:not(:disabled):hover {
        background-color: #f1f1f1;
        cursor: pointer;
      }
    }
    :deep(.vdp-datepicker__calendar) {
      z-index: 1;
      width: 240px;
      font-size: 13px;

      .cell {
        padding: 4px 4px;
        height: 28px;
        line-height: 20px;

        &.selected {
          background: $vis-primary-color;
          color: #FFF;

          &:hover {
            background: $vis-primary-color;
          }
        }

        &:not(.blank):not(.disabled).day:hover {
          border: 1px solid $vis-primary-color;
        }
      }
    }
  }
</style>